import { mdbContainer, mdbRow, mdbCol, mdbCardBody, mdbCard } from "mdbvue";
import { mapActions } from "vuex";
import Btn from "../../../../core/Button";
import Popup from "../../../../core/Popup";
import Swal from "sweetalert2";
import { required  } from "vuelidate/lib/validators";
import ValidationError from "../../../misc/ValidationError";
import Loader from "../../../../core/Loader";
import vSelect from "vue-select";
import Paginator from "../../../../core/Paginator.vue"
const Membership = {
    name: "Membership",
    components: {
        Loader,
        "v-select": vSelect,
        mdbContainer,
        mdbRow,
        mdbCol,
        mdbCardBody,
        mdbCard,
        Btn,
        Popup,
        ValidationError,
        Paginator
    },
    data() {
        return {
            search: '',
            isLoading: true,
            totalOfElements: 0,
            page: 1,
            visible: 'd-none',
            perPage: 10,
            listPaperwork: [],
            numberOfPages: 0,
            dataList: [],
            classPop: "popup__header-admin",
            isEdit: false,
            id: "",
            userTypeName: "",
            cloneUserTypeName: "",
            proceedingTypes: "",
            columns: [
                {
                    label: 'Tipo de usuario',
                    key: 'applicantTypeValue',
                    sort: false,
                    class: 'text-left',
                    thStyle: {
                        "font-size": "1.6rem",
                        "padding": "1.0rem 0.5rem",
                        "background-color": "#3a8a65",
                        "color": "#fff",
                        "border-top-left-radius": "5px",
                        "border-bottom-left-radius": "5px"
                    },
                    tdClass: "tableCol-start",
                    tdStyle: {
                        "font-size": "1.6rem",
                    }
                },
                {
                    label: 'Tipo de usuario',
                    key: 'proceedingTypes',
                    sort: false,
                    class: 'text-left',
                    thStyle: {
                        "font-size": "1.6rem",
                        "padding": "1.0rem 0.5rem",
                        "background-color": "#3a8a65",
                        "color": "#fff"
                    },
                    tdClass: "tableCol",
                    tdStyle: {
                        "font-size": "1.6rem",
                    }
                },
                {
                    label: 'Precio',
                    key: 'price',
                    sort: false,
                    class: 'text-left',
                    thStyle: {
                        "font-size": "1.6rem",
                        "padding": "1.0rem 0.5rem",
                        "background-color": "#3a8a65",
                        "color": "#fff"
                    },
                    tdClass: "tableCol",
                    tdStyle: {
                        "font-size": "1.6rem",
                    }
                },
                {
                    label: '', 
                    key: 'options', 
                    sort: false, 
                    class: 'text-center', 
                    thStyle: {
                        "font-size": "1.6rem",
                        "padding": "1.0rem 2.5rem",
                        "background-color": "#3a8a65",
                        "color": "#fff"
                    },
                    tdClass: "tableCol",
                    tdStyle: {
                        "font-size": "1.6rem",
                    }
                },
            ],
        };
    },
    validations: {
        userTypeName: {
            required
        },
        proceedingTypes: {
            required
        },
    },
    methods: {
        ...mapActions([
            "_createUserType",
            "_updateUserType",
            "_deleteUserType",
            "_getUserType",
            "_getPaperwork",
        ]),
        cleanData() {
            this.totalOfElements = 0;
            this.page = 1;
            this.perPage = 10;
            this.numberOfPages = 0;
            this.search = "";
            this.dataList = [];
        },
        async getPaperwork() {
            try {
                this.isLoading = true;
                const params = {
                    pageSize: 10000,
                    pageNumber: 0,
                    proceedingType: ''
                };
                const { data } = await this._getPaperwork(params);
                if (data.status === 200) {
                    const { data: paperwork } = data;
                    this.listPaperwork = paperwork.map(({proceedingTypeValue, id}) => {
                        return {
                            value: id,
                            label: proceedingTypeValue
                        }
                    });
                }else{
                    this.pushNotifyError();
                }
            }
            catch (error) {
                this.pushNotifyError();
            }
            finally {
                this.isLoading = false;
            }
        },
        async getUsersTypes() {
            try {
                this.isLoading = true;
                const params = {
                    pageSize: this.perPage,
                    pageNumber: this.page - 1,
                    applicantType: this.search
                };
                const { data } = await this._getUserType(params);
                if (data.status === 200) {
                    const { data: userTypes, totalElements, totalPages } = data;
                    this.numberOfPages = totalPages;
                    this.totalOfElements = totalElements;
                    this.dataList = userTypes;
                } else {
                    this.pushNotifyError();
                }
            }
            catch (error) {
                if (error && error.response && error.response.status === 404) {
                    this.dataList = [];
                } else {
                    this.pushNotifyError();
                }
            }
            finally {
                this.isLoading = false;
            }
        },
        async deleteUserType() {
            try {
                this.closeModal('delete');
                this.isLoading = true;
                const { data } = await this._deleteUserType({
                    id: this.id
                });
                if (data.status === 200) {
                    this.cleanData();
                    this.getUsersTypes();
                    this.alertSuccess(
                        'ELIMINACIÓN CORRECTA',
                        'Tipo de usuario eliminado correctamente.'
                    );
                }else{
                    this.pushNotifyError();
                }
            }
            catch (error) {
                this.pushNotifyError();
            }
            finally {
                this.isLoading = false;
            }
        },
        async createUserType() {
            try {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.closeModal('persist');
                this.isLoading = true;
                const body = {
                    applicantTypeValue: this.userTypeName,
                    proceedingTypes: this.proceedingTypes.map(({value}) => value),
                };
                const { data } = await this._createUserType(body);
                if (data.status === 201) {
                    this.cleanData();
                    this.getUsersTypes();
                    this.alertSuccess(
                        'REGISTRO CORRECTO',
                        'Registro de tipo de usuario realizado correctamente.'
                    );
                }
                else{
                    this.pushNotifyError();
                }
            }
            catch (error) {
                if (error && error.response && error.response.data &&  error.response.data.errorDetails) {
                    this.pushNotifyError(error.response.data.errorDetails);
                } else {
                    this.pushNotifyError();
                }
            }
            finally {
                this.isLoading = false;
            }
        },
        async updateUserType() {
            try {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.closeModal('persist');
                this.isLoading = true;
                const params = {
                    id: this.id,
                    body: {
                        proceedingTypes: this.proceedingTypes.map(({value}) => value),
                    }
                };

                if (this.cloneUserTypeName !== this.userTypeName) {
                    Object.assign(params.body, {applicantTypeValue: this.userTypeName})
                }

                const { data } = await this._updateUserType(params);
                if (data.status === 200) {
                    this.cleanData();
                    this.getUsersTypes();
                    this.alertSuccess(
                        'EDICIÓN CORRECTA',
                        'Edición de tipo de usuario realizada correctamente.'
                    );
                }else{
                    this.pushNotifyError();
                }
            }
            catch (error) {
                if (error && error.response && error.response.data &&  error.response.data.errorDetails) {
                    this.pushNotifyError(error.response.data.errorDetails);
                } else {
                    this.pushNotifyError();
                }
            }
            finally {
                this.isLoading = false;
            }
        },
        closeModal(modal) {
            this.isEdit = false;
            if (modal === 'delete'){
                this.$refs.deleteModal.toggleModal();
            } else {
                this.$refs.persistModal.toggleModal();
            }
        },
        async openCreateSellerModal(){
            await this.getPaperwork();
            this.isEdit = false;
            this.id = "";
            this.userTypeName = "";
            this.proceedingTypes = "";
            this.getPaperwork();
            this.$refs.persistModal.toggleModal();
        },
        async openEditModal({id, userTypeName, proceedingTypes}) {
            await this.getPaperwork();
            this.isEdit = true;
            this.id = id;
            this.cloneUserTypeName= userTypeName;
            this.userTypeName = userTypeName;
            this.proceedingTypes = proceedingTypes;
            this.$refs.persistModal.toggleModal();
        },
        openDeleteModal(id){
            this.id = id;
            this.$refs.deleteModal.toggleModal();
        },
        pushNotifyError(message = "Ha ocurrido un error, inténtalo más tarde."){
            this.$notify.error({
                message,
                position: "top right",
                timeOut: 15000
            });
        },
        alertSuccess(title, message) {
            Swal.fire({
                title:
                    `<span style='font-family: Josefin Sans,serif; font-size: 22px; font-weight: 600; color: #828282; font-stretch: normal; font-style: normal; line-height: normal;letter-spacing: normal;' >${title} </span>`,
                html:
                    "<div>" +
                    `<span class='mt-4'  style='font-family: Open Sans; font-size: 14px; color: #828282; font-weight: normal'>${message}</span>` +
                    "<br>"+
                    "<img alt='success_icon' src='/img/icons/ok.svg' style='width: 40%; margin-top: 3rem;' />" +
                    "</div>",
                width: "50rem",
                padding: "4rem",
                showConfirmButton: false,
                showCloseButton: true
            });
        },
        getProceedingTypes (proceedingTypes) {
            return proceedingTypes.map(({proceedingTypeValue}) => proceedingTypeValue).join(', ');
        },
        focusSelect (){
            this.visible = "";
        },
        blurSelect (){
            this.visible = "d-none";
        },
        changePage(value) {
            this.page = value
        },
        changePerPage(value) {
            this.perPage = value
        },
    },
    mounted() {
        this.cleanData();
        this.getUsersTypes();
    },
    watch: {
        async search(){
            await this.getUsersTypes();
        },
        async page(){
            await this.getUsersTypes();
        },
        async perPage() {
            await this.getUsersTypes();
        },
    },
};

export default Membership;